
import React from 'react';
import _ from 'lodash';
import {
    CUSTOM_INTEGREDIENT, NO_SHOPS, ERROR_POSITIVE_VALUE,
    ERROR_DATE_CONFLICT, ERROR_TOO_SHORT_PERIOD,
    ERROR_CREATE_CAMPAIGN_MARKETING,
    ERROR_PRODUCT, ERROR_PRODUCT_CONFLICT, INVALID_START_DATE,
    INVALID_DATA, NO_PURCHASED_PRODUCT, INVALID_VALUE, NO_SELECTED_PRODUCT, SUCCESS_UPDATE_TEXT, ERROR_DUPLICATE_OFFER
} from '../../constants';
import { createCampaignMarketing, updateMarketingCampaign } from '../../apis/backend';
import {
    CampaignItem, MARKETING_CAMPAIGN_IS_ABOUT_TO_START, FREEDELIVERYAFTERTHRESHOLD,
    MARKETING_CAMPAIGN_DATE_CONFLICT, MARKETING_CAMPAIGN_PRODUCT_CONFLICT, MARKETING_CAMPAIGN_IS_TOO_SHORT,
    PRODUCTDISCOUNTAFTERTHRESHOLD, PRODUCTDISCOUNT, MARKETING_CAMPAIGN_STATUS, TYPES
} from '../../constants/marketingCampaign'
import { showNotification } from '../../components/Notification/Notification.view';
import { getAllCampaigns } from '../MarketingCampaigns/MarketingCampaigns.services';
import { combineDateAndTime, formatDateTime } from '../../utils/tools'
import moment, { Moment } from 'moment';
export interface Product {
    ref: string;
    name: string;
    key: string;
    price: number
}
export interface Menu {
    [shopId: string]: {
        sections: {
            [sectionId: string]: {
                name: string,
                position: number,
                products?: {
                    [productId: string]: Product;
                };
            };
        };
    };
}
export interface Section {
    id: string;
    name: string;
    products: Product[];
    position: number;
}


export const handleRestaurantOpenModal = (
    campaign: CampaignItem,
    setOpenRestaurantModal: React.Dispatch<React.SetStateAction<any>>,
    setSelectedCampaign: React.Dispatch<React.SetStateAction<any>>,
    setSelectedShops: React.Dispatch<React.SetStateAction<any>>,
) => {
    setOpenRestaurantModal(true);
    setSelectedShops([]);
    setSelectedCampaign(campaign);
};

export const handleOpenOneShopModal = (campaign: CampaignItem, setSelectedCampaign: React.Dispatch<React.SetStateAction<any>>, shopId: number, setSelectedShops: React.Dispatch<React.SetStateAction<any>>, setOpenModal: React.Dispatch<React.SetStateAction<any>>) => {
    setSelectedCampaign(campaign);
    setSelectedShops([shopId]);
    setOpenModal(true);
}



export const getCommonProductsBySection = (shopIds: string[], menus: Menu): Section[] => {
    if (!menus || !shopIds || !shopIds.length) {
        return [];
    }

    const shopSections = shopIds.map(shopId => {
        const menu = menus[shopId];
        if (!menu || !menu.sections) return [];

        return Object.entries(menu.sections).map(([sectionId, section]) => ({
            sectionId,
            sectionName: section?.name || `Section ${sectionId}`,
            position: section?.position ?? 0,
            products: section?.products ? Object.values(section.products) : []
        }));
    });

    if (shopSections.some(sections => sections.length === 0)) {
        return [];
    }

    const commonSectionIds = _.intersection(
        ...shopSections.map(sections => sections.map(s => s.sectionId))
    );

    const result = commonSectionIds
        .map(sectionId => {
            const baseSection = shopSections[0].find(s => s.sectionId === sectionId);
            const sectionName = baseSection?.sectionName || `Section ${sectionId}`;
            const position = baseSection?.position ?? 0;

            const allSectionProducts = shopSections.map(sections => {
                const section = sections.find(
                    s => s.sectionId === sectionId && !CUSTOM_INTEGREDIENT.includes(sectionId)
                );
                return section ? section.products : [];
            });

            const commonProducts = allSectionProducts.reduce((common, products) => {
                if (!common?.length) return products;
                return common.filter(product =>
                    products.some(p => p.key === product.key)
                );
            }, [] as Product[]);

            return {
                id: sectionId,
                name: sectionName,
                position,
                products: _.uniqBy(commonProducts, 'key')
            };
        })
        .filter(section => section.products.length > 0);

    return _.sortBy(result, 'position');
};


export const handleRestaurantsValidate = (selectedShopIds: string[], setSelectedShops, setOpenModal, openErrorModal, setOpenRestaurantModal) => {
    if (_.size(selectedShopIds) === 0 || !selectedShopIds) { openErrorModal(NO_SHOPS); return; }
    setSelectedShops(selectedShopIds);
    setOpenRestaurantModal(false)
    setOpenModal(true);


};


export const handlePromoValidate = async (
    formValues: any,
    selectedShops: string[],
    setOpenModal: React.Dispatch<React.SetStateAction<any>>,
    setOpenRestaurantModal: React.Dispatch<React.SetStateAction<any>>,
    openErrorModal: (message: string) => void,
    setIsLoading: React.Dispatch<React.SetStateAction<any>>,
    withoutProductSelection: boolean,
    isUpdate?: boolean,
    setMarketingCampaigns?: any,
) => {
    setIsLoading(true)
    const minValidDate = (date) => formatDateTime(date.clone().add(15, 'minutes'));
    const formattedStartDate = combineDateAndTime(formValues.startDate, formValues.startTime);
    const formattedEndDate = combineDateAndTime(formValues.endDate, formValues.endTime);
    const validateFormData = (data: any) => {
        const { startDate, startTime, endTime, endDate } = formValues;
        const startMoment = moment(startDate);
        const now = moment();
        const isStartValid = isDateValid(startMoment, startTime, now);
        const isEndValid = isDateValid(moment(endDate), endTime, startMoment);
        if (!isStartValid) {
            return {
                valid: false,
                error: INVALID_START_DATE(minValidDate(now))
            };
        }

        if (!isEndValid) {
            return {
                valid: false,
                error: ERROR_TOO_SHORT_PERIOD(minValidDate(moment(formattedStartDate)))
            };
        }
        const invalidValues = [
            data.config.discount?.value,
            data.config.threshold,
            data.config.limit
        ];

        if (invalidValues.some(v => v === null || v <= 0)) {
            return { valid: false, error: ERROR_POSITIVE_VALUE };
        }
        if (data.config.discount?.type === TYPES.CASH && data.config.discount?.value && data.config.threshold &&
            Number(data.config.discount.value) >= Number(data.config.threshold)) {
            return { valid: false, error: INVALID_DATA };
        }

        if (data.config.discount?.type === TYPES.PERCENTAGE && Number(data.config.discount.value) > 100) {
            return { valid: false, error: INVALID_VALUE };
        }
        if (!withoutProductSelection && (!data.config.products || _.size(data.config.products) === 0)) {
            return { valid: false, error: NO_SELECTED_PRODUCT };
        }
        return { valid: true, error: '' };
    };

    try {


        const firebaseData = setFormValues(
            formValues,
            formattedStartDate,
            formattedEndDate,
            selectedShops,
            withoutProductSelection,
            isUpdate

        );

        const validation = validateFormData(firebaseData);
        if (!validation.valid) {
            return openErrorModal(validation.error);
        }
        if (isUpdate) {
            await updateMarketingCampaign(formValues?.marketingCampaignKey, firebaseData)
            await getAllCampaigns(setMarketingCampaigns, [MARKETING_CAMPAIGN_STATUS.PENDING])
        }
        else await createCampaignMarketing(firebaseData)
        setOpenModal(false);
        setOpenRestaurantModal(false);
        setIsLoading(false)
        showNotification(
            'light',
            'ltr',
            'primary',
            isUpdate ? SUCCESS_UPDATE_TEXT : 'Création réussie',
            isUpdate ? 'La campagne promotionnelle a bien été modifiée' : 'La campagne promotionnelle a bien été créée'
        );

    } catch (error: any) {
        const errorName = error.response?.data?.errorName;
        const errorMessages = {
            [MARKETING_CAMPAIGN_DATE_CONFLICT]: ERROR_DATE_CONFLICT,
            [MARKETING_CAMPAIGN_IS_TOO_SHORT]: ERROR_TOO_SHORT_PERIOD(minValidDate(moment(formattedStartDate))),
            [MARKETING_CAMPAIGN_IS_ABOUT_TO_START]: INVALID_START_DATE(minValidDate(moment())),
            [MARKETING_CAMPAIGN_PRODUCT_CONFLICT]: ERROR_PRODUCT_CONFLICT,
        };
        const errorMessage = errorMessages[errorName] || ERROR_CREATE_CAMPAIGN_MARKETING;
        setIsLoading(false)
        openErrorModal(errorMessage);
    }
    finally {
        setIsLoading(false);
    }
};

const setFormValues = (
    formValues: any,
    formattedStartDate: string,
    formattedEndDate: string,
    selectedShops: string[],
    withoutProductSelection: boolean,
    isUpdate?: boolean
) => {
    const firebaseData: {
        config: {
            threshold?: number | null;
            discount?: { type: string; value: number | null };
            limit?: number | null;
            products?: any;
        };
        dateStart: string;
        dateEnd: string;
        type?: string;
        shopIds?: string[];
    } = {
        config: {},
        dateStart: formattedStartDate,
        dateEnd: formattedEndDate
    };
    if (!isUpdate) {
        firebaseData.type = formValues.type
        firebaseData.shopIds = selectedShops
    }
    if (
        (withoutProductSelection && formValues.type !== FREEDELIVERYAFTERTHRESHOLD) ||
        (!withoutProductSelection && (formValues.type === PRODUCTDISCOUNTAFTERTHRESHOLD || formValues.type === PRODUCTDISCOUNT))
    ) {
        firebaseData.config.discount = {
            type: formValues.valueType,
            value: formValues.discount ? Number(formValues.discount) : null,
        };
    }


    if (withoutProductSelection || (!withoutProductSelection && formValues.type === PRODUCTDISCOUNTAFTERTHRESHOLD)) {
        firebaseData.config.threshold = formValues.threshold ? Number(formValues.threshold) : null;
    }

    if (formValues?.hasLimit && !withoutProductSelection) {
        firebaseData.config.limit = formValues.limit ? Number(formValues.limit) : null;
    }


    if (!withoutProductSelection) {
        firebaseData.config.products = formValues.products.map(product => {
            const { productOffredName, productName, ...rest } = product;
            return rest;
        });
    }

    return firebaseData;
};



export const handleProductToggle = (
    product,
    sectionKey,
    setPurchasedProducts,
    setFormValues,
    withAddButton
) => {
    setPurchasedProducts(prev => {
        const index = prev.findIndex(item => item.productKey === product.key);

        if (index !== -1) {
            const updated = [...prev];
            updated.splice(index, 1);
            return updated;
        } else {
            return [
                ...prev,
                {
                    productKey: product.key,
                    productOfferedKey: product.key,
                    productName: product.name,
                    productSectionKey: sectionKey,
                    productOfferedSectionKey: sectionKey,
                    productOfferedName: product.name,
                },
            ];
        }
    });

    if (!withAddButton) {
        setFormValues(prev => {
            const currentProducts = Array.isArray(prev.products) ? prev.products : [];
            const productIndex = currentProducts.findIndex(p => p.productKey === product.key);

            if (productIndex !== -1) {
                const updatedProducts = [...currentProducts];
                updatedProducts.splice(productIndex, 1);
                return {
                    ...prev,
                    products: updatedProducts
                };
            } else {
                return {
                    ...prev,
                    products: [
                        ...currentProducts,
                        {
                            productKey: product.key,
                            productSectionKey: sectionKey
                        }
                    ]
                };
            }
        });
    }

};


export const handleDateChange = (date, field, setFormValues) => {
    setFormValues(prev => ({
        ...prev,
        [field]: date,
    }));
};



export const handleDelete = (index, setters, setFormValues) => {
    if (!setters || !Array.isArray(setters)) return;

    setters.forEach(setter => {
        if (typeof setter === 'function') {
            setter(prev => Array.isArray(prev) ? prev.filter((_, i) => i !== index) : prev);
        }
    });

    if (setFormValues && typeof setFormValues === 'function') {
        setFormValues(prev => ({
            ...prev,
            products: Array.isArray(prev?.products) ? prev.products.filter((_, i) => i !== index) : []
        }));
    }
};
export const handlePurchasedProductToggle = (
    product,
    sectionKey,
    setOfferedProducts
) => {
    setOfferedProducts(prev => {
        if (prev.some(item => item.productKey === product.key)) {
            return prev.filter(item => item.productKey !== product.key);
        }
        return [
            {
                productKey: product.key,
                productSectionKey: sectionKey,
                productName: product.name,
                productOfferedKey: null,
                productOfferedSectionKey: null,
                productOfferedName: null
            }
        ];
    });
};

export const handleOfferedProductToggle = (
    product,
    sectionKey,
    setOfferedProducts,
    offeredProducts,
    openErrorModal
) => {
    if (!offeredProducts || !offeredProducts.some(item => item.productKey)) {
        openErrorModal(NO_PURCHASED_PRODUCT);
        return;
    }

    setOfferedProducts(prev => {
        if (prev.some(item => item.productOfferedKey === product.key)) {
            return prev.map(item =>
                item.productOfferedKey === product.key
                    ? {
                        ...item,
                        productOfferedKey: null,
                        productOfferedSectionKey: null,
                        productOfferedName: null
                    }
                    : item
            );
        }
        return prev.map(item => ({
            ...item,
            productOfferedKey: product.key,
            productOfferedSectionKey: sectionKey,
            productOfferedName: product.name
        }));
    });
};


export const handleAddOfferedProducts = (
    offeredProducts,
    setSelectedProducts,
    setFormValues,
    openErrorModal,
    setOfferedProducts,
    setExpandedOffered,
    setExpandedPurchased
) => {
    const isValid = offeredProducts.some(
        item => item.productKey && item.productOfferedKey
    );

    if (!isValid) {
        openErrorModal(ERROR_PRODUCT);
        return;
    }

    const newOffer = offeredProducts.find(item => item.productKey && item.productOfferedKey);
    const offerKey = `${newOffer.productKey}-${newOffer.productOfferedKey}`;

    setSelectedProducts(prev => {
        const existingKeys = new Set(prev.map(p => `${p.productKey}-${p.productOfferedKey}`));

        if (existingKeys.has(offerKey)) {
            openErrorModal(ERROR_DUPLICATE_OFFER);
            return prev;
        }

        return [...prev, newOffer];
    });

    setFormValues(prev => {
        const existingProducts = prev.products || [];
        const existingKeys = new Set(existingProducts.map(p => `${p.productKey}-${p.productOfferedKey}`));

        if (existingKeys.has(offerKey)) {
            return prev;
        }

        const { productName, productOfferedName, ...rest } = newOffer;
        return {
            ...prev,
            products: [...existingProducts, rest]
        };
    });

    setOfferedProducts([]);
    setExpandedOffered(false);
    setExpandedPurchased(true);
};

export const handleAddProducts = (purchasedProducts, setSelectedProducts, setFormValues, setDisabledPurshasedProducts) => {
    setSelectedProducts(prev => {
        const existingKeys = new Set(prev.map(p => p.productKey));
        const newProducts = purchasedProducts.filter(p => !existingKeys.has(p.productKey));
        return [...prev, ...newProducts];
    });

    setFormValues(prev => {
        const existingProducts = prev.products || [];
        const existingKeys = new Set(existingProducts.map(p => p.productKey));
        const newProducts = purchasedProducts
            .filter(p => !existingKeys.has(p.productKey))
            .map(({ productName, productOfferedName, ...rest }) => rest);

        return { ...prev, 'products': [...existingProducts, ...newProducts] };
    });
    setDisabledPurshasedProducts(purchasedProducts)
};

const isDateValid = (date: Moment, time: string, startDate: Moment): boolean => {
    const [hours, minutes] = time.split(':').map(Number);
    const selectedDate = date.hours(hours).minutes(minutes).seconds(0).milliseconds(0);
    const minValidDate = startDate.clone().add(15, 'minutes');

    return selectedDate.isSameOrAfter(minValidDate);
};
